export enum XpoBoardDataFetchState {
  Error = 'error',
  Loading = 'loading',
  NoResults = 'no-results',
  ResultsReturned = 'results-returned',
}
